import { render, staticRenderFns } from "./StepsOs.vue?vue&type=template&id=274a878e&scoped=true&"
import script from "./StepsOs.vue?vue&type=script&lang=js&"
export * from "./StepsOs.vue?vue&type=script&lang=js&"
import style0 from "./StepsOs.vue?vue&type=style&index=0&id=274a878e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a878e",
  null
  
)

export default component.exports